import React from 'react';
import CurrencyFormat from 'react-number-format';
import Tooltip from 'react-tooltip-lite';
import Icon from '../../../assets/icons/Icon';
import ContentLoader from '../../../components/ContentLoader';
import { useDict } from '../../../contexts/LanguageContext';

const FilteringChartPerformance = ({
    annualRate,
    accumulatedReturn,
    isLoading,
}) => {
    const dict = useDict();

    const renderWithLoader = (component) => {
        if (isLoading) {
            return (
                <div className="d-flex justify-content-end">
                    <ContentLoader width="100" height="20" color="loader500">
                        <rect width="100%" height="100%" y="0" rx="4" ry="4" />
                    </ContentLoader>
                </div>
            );
        }
        return component;
    };

    return (
        <div className="performance__summary">
            <span>{dict.annualReturn}</span>
            {renderWithLoader(
                <span>{parseFloat(annualRate).toFixed(1)} %</span>
            )}
            <div />
            <span>
                {dict.accumulatedReturn}&nbsp;
                <Tooltip
                    content={dict.accumulatedReturnTooltip}
                    styles={{ display: 'inline' }}
                    distance={5}
                    arrowSize={8}
                >
                    <Icon icon="InfoCircle" width="11" />
                </Tooltip>
            </span>
            {renderWithLoader(
                <CurrencyFormat
                    className="dashboard__competitor-performance-annual"
                    value={accumulatedReturn}
                    displayType="text"
                    thousandSeparator
                    prefix="฿ "
                />
            )}
        </div>
    );
};

export default FilteringChartPerformance;
